// @flow
import { useEffect } from 'react';

type Props = {
  children: React.Node,
  selector: string,
};

const HideElement = ({ children, selector }: Props) => {
  useEffect(() => {
    const element = document.querySelector(selector);

    if (element) {
      element.style.display = 'none';
    }

    return () => {
      if (element) {
        element.style.display = 'initial';
      }
    };
  });

  return children;
};

/** @component */
export default HideElement;
